import { TextInputWithTokens } from '@primer/react';
import * as React from 'react';
export default {
  TextInputWithTokens,
  React
};